module.exports = __webpack_public_path__ + "static/media/share-gray.f2a16634.svg";